import { FeatureAccessFlags } from "services/subscriptions/model";

export type PricingModel = {
  id: string;
  name: string;
  code: string;
  description: string;
  target_audience?: string;
  benefits?: string;
  url: string;
  currency: string;
  type: PurchaseStudentType;
  items: PricingModelItem[];
  is_selected: boolean;
};

export type PurchaseStudentType = "one-on-one" | "self-study";
export type PurchaseType = "one-time" | "subscription";

export type PricingModelTeam = {
  id: string;
  name: string;
  company: {
    id: string;
    name: string;
  } | null;
};

export type PricingModelStudent = {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  created: string;
};

export type PricingModelItem = {
  id: string;
  name: string;
  order_number: number;
  price: number;
  ai_tokens: number | null;
  currency: string;
  purchase_student_type: PurchaseStudentType;
  purchase_type: PurchaseType;
  number: number | null;
  length: number | null;
  included_content: FeatureAccessFlags;
};

// Subscription lengths are stored as day counts; 30 (monthly) and 365 (yearly) are the
// only values used in practice.
export const DAYS_PER_MONTH = 30;
export const DAYS_PER_YEAR = 365;

export const isPricingModelItemMonthly = (item: PricingModelItem) =>
  item.purchase_type === "subscription" && item.length === DAYS_PER_MONTH;
